import Image from 'next/image';
import React from 'react';

type ImageProps = {
  url?: string;
  alternativeText?: string;
};

type ImagesProps = {
  item: ImageProps & {
    image: ImageProps;
  };
};

export default function ArticleImage({ item }: ImagesProps) {
  return (
    <Image
      src={item.url || item.image?.url || ''}
      alt={item.alternativeText || item.image?.alternativeText || ''}
      width={650}
      height={0}
      style={{
        margin: '30px auto 20px',
      }}
    />
  );
}
